/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IRRPeriod } from './IRRPeriod';
import {
    IRRPeriodFromJSON,
    IRRPeriodFromJSONTyped,
    IRRPeriodToJSON,
} from './IRRPeriod';

/**
 * 
 * @export
 * @interface IRR
 */
export interface IRR {
    /**
     * 
     * @type {IRRPeriod}
     * @memberof IRR
     */
    iRRPeriod: IRRPeriod;
    /**
     * 
     * @type {number}
     * @memberof IRR
     */
    netIRR?: number;
    /**
     * 
     * @type {number}
     * @memberof IRR
     */
    grossIRR?: number;
}

/**
 * Check if a given object implements the IRR interface.
 */
export function instanceOfIRR(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "iRRPeriod" in value;

    return isInstance;
}

export function IRRFromJSON(json: any): IRR {
    return IRRFromJSONTyped(json, false);
}

export function IRRFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRR {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iRRPeriod': IRRPeriodFromJSON(json['IRRPeriod']),
        'netIRR': !exists(json, 'NetIRR') ? undefined : json['NetIRR'],
        'grossIRR': !exists(json, 'GrossIRR') ? undefined : json['GrossIRR'],
    };
}

export function IRRToJSON(value?: IRR | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IRRPeriod': IRRPeriodToJSON(value.iRRPeriod),
        'NetIRR': value.netIRR,
        'GrossIRR': value.grossIRR,
    };
}

